import React, { useState, useRef, useEffect  } from 'react'
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import {uploadDocument, deleteDocument} from "../../../core/img/imagewithbasebath";
import { set_page_refresh } from '../../../core/redux/action';
import { bucketObj } from "../../../environment";
import axios from 'axios';
// Map upload labels with keys
const DOCUMENT_TYPES = [
  { label: "Export Certificate (Original)", key: "exportOriginal" },
  { label: "Export Certificate (English)", key: "exportEnglish" },
  { label: "Inspection Certificate", key: "inspectionCert" },
  { label: "Bill of Lading (B/L) Copy", key: "blCopy" },
  { label: "B/L Surrender Copy", key: "blSurrender" },
  { label: "DHL Tracking", key: "dhlTrackingFile" },
];


const UploadDocuments = ({ record, dataStore }) => {
    console.log("storeData2", dataStore);
     console.log("record?.documents", record?.documents);
    
  console.log("record", record);
  const dispatch = useDispatch();
  const fileInputRefs = useRef({});
  const closeRef = useRef(null)
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");

  const [uploadedDocs, setUploadedDocs] = useState({});
  const [docTracking, setDocTracking] = useState("");

  // Load existing data when component mounts or record changes
  // useEffect(() => {
  //   if (record) {
  //     // Set tracking number if it exists
  //     if (record.docTracking) {
  //       setDocTracking(record.docTracking);
  //     }
      
  //     // Set documents if they exist
  //     if (record.documents && typeof record.documents === 'object') {
  //       setUploadedDocs(record.documents);
  //     }
  //   }
  //   else {
  //      setDocTracking("");
  //      setUploadedDocs({});
  //   }
  // }, [record?.documents]);

  useEffect(() => {
  if (record) {
    // Set tracking number if it exists
    if (record.docTracking) {
      setDocTracking(record.docTracking);
    } else {
      setDocTracking(""); // clear if not present
    }

    // Set documents if they exist
    if (record.documents && typeof record.documents === 'object') {
      setUploadedDocs(record.documents);
    } else {
      setUploadedDocs({});
    }
  } else {
    setDocTracking("");
    setUploadedDocs({});
  }
}, [record]); // <-- changed from [record?.documents] to [record]

  const handleFileChange = async (e, docKey) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const uploadedKey = await uploadDocument(file, 'documents',record._id, docKey);
      const newDoc = {
        name: file.name,
        key: uploadedKey,
        // url: `https://res.public.s3.amazonaws.com/uploads/${uploadedKey}`
      };

      setUploadedDocs(prev => ({
        ...prev,
        [docKey]: newDoc
      }));
    } catch (err) {
      console.error('Upload failed', err);
      alert("Failed to upload document.");
    }
  };

  const handleRemove = async (docKey) => {
    if (uploadedDocs[docKey]?.key) {
      const success = await deleteDocument(uploadedDocs[docKey].key);
      if (success) {
        console.log("Document deleted successfully");
        setUploadedDocs(prev => {
          const updated = { ...prev };
          delete updated[docKey];
          return updated;
        });
      // Clear the file input
        if (fileInputRefs.current[docKey]) {
          fileInputRefs.current[docKey].value = '';
        }
    }
  }

  };


  const handleSubmit = async () => {
  try {
    // Prepare the payload with documents and tracking reference
    const payload = {
      _id: record._id,
      documents: uploadedDocs,
      docTracking: docTracking,
      doc: true
    };

    // Call your API
    await axios.post('addupdateorder/', payload);
    
    // Handle success
    dispatch(set_page_refresh("saleslist"));
    closeRef.current?.click()
    document.querySelector(".modal-backdrop")?.classList?.toggle("show");
    alert("Documents and tracking information submitted successfully!");
     setDocTracking("");
    setUploadedDocs({});
    Object.keys(fileInputRefs.current).forEach(key => {
      if (fileInputRefs.current[key]) {
        fileInputRefs.current[key].value = '';
      }
    });
  } catch (err) {
    console.error('Submission failed', err);
    alert("Failed to submit documents and tracking information.");
  }
};

  return (
    <div>
      <div className="modal fade" id="modal_upload_documents">
        <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t?.[l]?.["upload_documents"] || "Upload Documents"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>

                <div className="modal-body custom-modal-body">
                  <form>
                    {/* DHL Reference Number */}
                    <div className="row mb-3">
                      <div className="col-lg-12">
                        <label className="form-label">{t[l]?.["dhl_tracking_reference_number"] || "DHL Tracking Reference Number"}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={docTracking}
                          onChange={(e) => setDocTracking(e.target.value)}
                          placeholder={t[l]?.["enter_dhl_tracking_reference"] ||"Enter DHL Tracking Reference"}
                          maxLength={25}
                        />
                      </div>
                    </div>

                    {/* Upload Fields */}
                    {DOCUMENT_TYPES.reduce((rows, doc, index) => {
                        if (index % 3 === 0) rows.push([]);
                        rows[rows.length - 1].push(doc);
                        return rows;
                        }, []).map((row, rowIndex) => (
                        <div className="row mb-3" key={`row-${rowIndex}`}>
                            {row.map((doc) => (
                            <div className="col-lg-4" key={doc.key}>
                                <label className="form-label">
                                  {t[l]?.[doc.key] || doc.label}</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={(e) => handleFileChange(e, doc.key)}
                                  accept=".jpg,.jpeg,.png,.pdf,.docx"
                                  ref={el => fileInputRefs.current[doc.key] = el}
                                />
                                {uploadedDocs[doc.key] && (
                                <div className="mt-2 d-flex justify-content-between align-items-center bg-light p-2 rounded">
                                    <span className="text-truncate text-black" style={{ maxWidth: '60%' }} >{uploadedDocs[doc.key].name}</span>
                                    <div className="d-flex">
                                     <a
                                        href={bucketObj.bucketUrl + bucketObj.objectKey + uploadedDocs[doc.key].key}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-primary me-2"
                                    >
                                        {t[l]?.["view"] || "View"}
                                    </a>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleRemove(doc.key)}
                                    >
                                         {t[l]?.["remove"] || "Remove"}
                                    </button>
                                    </div>
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                        ))}


                    <div className="col-lg-12 mt-4">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          {t?.[l]?.["cancel"] || "Cancel"}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-submit"
                          onClick={(e) => {
                            e.preventDefault();
                            handleSubmit();
                          }}
                        >
                          {t?.[l]?.["submit"] || "Submit"}
                        </button>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

UploadDocuments.propTypes = {
  record: PropTypes.object,
  dataStore: PropTypes.array
};

export default UploadDocuments;